import { useLanguage } from './language-context';
import { useTheme } from './theme-context';
import { ScIcon } from './chrome-icons';

// The design's sun/moon theme switch (Blog design export `.tsw`): a real switch, so a
// screen reader announces on/off for "Dark mode" rather than reading a glyph. Clicking
// sets an explicit light/dark preference. The header draws the 64 x 36 size; the footer
// bar's CSS enlarges it to 76 x 44.
export function ThemeSwitch() {
  const { t } = useLanguage();
  const { resolved, setPref } = useTheme();
  const isDark = resolved === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={t('sc.dark_mode')}
      title={t(isDark ? 'theme.switch_to_light' : 'theme.switch_to_dark')}
      className="sc-tsw"
      onClick={() => setPref(isDark ? 'light' : 'dark')}
    >
      <span className="sc-tk">
        <ScIcon id="sc-i-sun2" className="sc-sun" />
        <ScIcon id="sc-i-moon2" className="sc-moon" />
      </span>
    </button>
  );
}
